import { render, staticRenderFns } from "./carDetails.vue?vue&type=template&id=527100b1&scoped=true"
import script from "./carDetails.vue?vue&type=script&lang=js"
export * from "./carDetails.vue?vue&type=script&lang=js"
import style0 from "./carDetails.vue?vue&type=style&index=0&id=527100b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527100b1",
  null
  
)

export default component.exports